import { getDeliverySolutions } from '@wix/ambassador-gateways-ecom-v1-delivery-rates-gateway/http';
export const getDeliveryOptions = async (httpClient, params) => {
  const response = await httpClient.request(getDeliverySolutions(params));
  return response.data;
};
//# sourceMappingURL=deliveryOptionsUtils.js.map